import { assertSupabaseConfigured, supabase } from "../lib/supabase";
import type { AuditLog } from "../types/admin";

export const auditLogService = {
  async listAuditLogs(filters?: {
    search?: string;
    tenantId?: string;
    action?: string;
    entityType?: string;
    limit?: number;
  }): Promise<AuditLog[]> {
    assertSupabaseConfigured();

    let query = supabase
      .from("audit_logs")
      .select("*, tenants(id,name,slug), profiles(id,email,full_name)")
      .order("created_at", { ascending: false })
      .limit(filters?.limit ?? 100);

    if (filters?.tenantId && filters.tenantId !== "all") {
      query = query.eq("tenant_id", filters.tenantId);
    }

    if (filters?.action?.trim()) {
      query = query.ilike("action", `%${filters.action.trim()}%`);
    }

    if (filters?.entityType && filters.entityType !== "all") {
      query = query.eq("entity_type", filters.entityType);
    }

    const { data, error } = await query;

    if (error) {
      throw error;
    }

    const logs = (data ?? []) as AuditLog[];
    const search = filters?.search?.trim().toLowerCase();

    if (!search) {
      return logs;
    }

    return logs.filter((log) =>
      [log.action, log.entity_type, log.profiles?.email, log.tenants?.name]
        .filter(Boolean)
        .some((value) => String(value).toLowerCase().includes(search)),
    );
  },
};
